import { X } from "lucide-react";

export function Modal({ title, onClose, children, wide = false }) {
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center bg-ink/60 backdrop-blur-sm overflow-y-auto py-10 px-4" onClick={onClose} data-testid="admin-modal">
      <div
        className={`bg-white rounded-2xl shadow-2xl w-full ${wide ? "max-w-3xl" : "max-w-lg"} p-6 sm:p-8`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <h3 className="font-display text-xl font-bold text-ink">{title}</h3>
          <button onClick={onClose} className="p-2 text-stone2 hover:text-ruby" data-testid="modal-close-btn" aria-label="Close">
            <X className="w-5 h-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

const STATUS_STYLES = {
  published: "bg-jade-light text-jade",
  pending: "bg-gold-light text-gold-dark",
  rejected: "bg-ruby-light text-ruby",
  suspended: "bg-sand text-clay",
  active: "bg-jade-light text-jade",
  paused: "bg-gold-light text-gold-dark",
  draft: "bg-sand text-clay",
  ended: "bg-sand text-stone2",
  paid: "bg-jade-light text-jade",
  invoiced: "bg-gold-light text-gold-dark border border-gold/40",
  unpaid: "bg-ruby-light text-ruby",
  new: "bg-gold-light text-gold-dark",
  read: "bg-sand text-clay",
  replied: "bg-jade-light text-jade",
  contacted: "bg-jade-light text-jade",
  quoted: "bg-jade-light text-jade",
  converted: "bg-jade-light text-jade",
  declined: "bg-ruby-light text-ruby",
  coming_soon: "bg-gold-light text-gold-dark",
  hidden: "bg-sand text-clay",
  disabled: "bg-ruby-light text-ruby",
};

export function StatusBadge({ status, label }) {
  return (
    <span className={`inline-flex px-2.5 py-1 rounded-md text-[11px] font-semibold uppercase tracking-wider ${STATUS_STYLES[status] || "bg-sand text-clay"}`} data-testid={`status-badge-${status}`}>
      {label || String(status || "").replace(/_/g, " ")}
    </span>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="block text-xs font-semibold uppercase tracking-wider text-stone2 mb-1.5">{label}</span>
      {children}
    </label>
  );
}

export const inputCls =
  "w-full px-3.5 py-2.5 rounded-xl bg-sand/60 text-sm text-ink outline-none border border-transparent focus:border-gold";

export const thCls = "px-4 py-3 text-[11px] font-semibold uppercase tracking-wider text-stone2";
export const tdCls = "px-4 py-3.5 text-sm text-ink align-middle";
